import * as React from 'react';
import useScreenOrientation from './helpers/useScreenOrientation';

export default function AnimationInfo({showProductAnimation, setShowProductAnimation}: any) {

  const isLandscape = useScreenOrientation();

  return (
    <div className={`animation-info-container`}>

      {!isLandscape &&
      <div className={`animation-info-button ${showProductAnimation ? 'selected' : ''}`} onClick={() => setShowProductAnimation(!showProductAnimation)}>
        {showProductAnimation ? "Detener animación" : "Iniciar animación"}
      </div>}
      <div className={`animation-info-bullet`}>
      </div>
      {isLandscape &&
      <div className={`animation-info-button ${showProductAnimation ? 'selected' : ''}`} onClick={() => setShowProductAnimation(!showProductAnimation)}>
        {showProductAnimation ? "Detener animación" : "Iniciar animación"}
      </div>}
      
    </div>
  );
}
